module.exports = __webpack_public_path__ + "img/file.73a1d07d.svg";